import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import { useSelector } from "react-redux";
import { Button } from "react-bootstrap";
import PulseLoader from "react-spinners/PulseLoader";

import AIFunctionalityModal from "@/Components/TreatmentPage/components/new/AI-Functionality-Modal";

import useGetAISystem from "../Components/FirmSettings/ai-systems/hooks/useGetAISystem";
import EditDeleteModal from "../Components/TreatmentPage/modals/edit-delete-modal-date/edit-detete-panel-for-dates-view";
// import TFIcon from "../Components/TreatmentPage/icon/TFIcon.svg";
import incidentIcon from "../assets/images/incident.svg";
import { api_without_cancellation } from "../api/api";
// import chevronRight from "../../public/BP_resources/images/icon/chevron_right.svg";
import {
  addClickRecord,
  currencyFormat,
  formatDate,
  getCaseId,
  getClientId,
} from "../Utils/helper";
import ClientProvidersStyles from "../Components/CaseDashboard/ClientProvidersStyles";
import AddAIDateModal from "../Components/TreatmentPage/modals/AIDateModal";
import powerbtn from "../assets/power-button.svg";
import addIconGold from "../assets/Add-icon-gold.svg";
import sortIcon from "../assets/sort.svg";

import DatesGapDropdown from "./DatesGapDropdown";
import { sortChronology } from "./chronologySort.mjs";

function mixColorWithWhite(hex, percentage) {
  const whitePercentage = (100 - percentage) / 100;

  let r = parseInt(hex.slice(1, 3), 16);
  let g = parseInt(hex.slice(3, 5), 16);
  let b = parseInt(hex.slice(5, 7), 16);

  // Mix each channel with white
  r = Math.floor(r + (255 - r) * whitePercentage);
  g = Math.floor(g + (255 - g) * whitePercentage);
  b = Math.floor(b + (255 - b) * whitePercentage);

  return `#${r.toString(16).padStart(2, "0")}${g.toString(16).padStart(2, "0")}${b.toString(16).padStart(2, "0")}`;
}
const LightBgParagraph = styled.p`
  background-color: ${({ speciality }) => mixColorWithWhite(speciality?.color, 10)} !important;
`;

const ChronologyView = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;

  label:has(input:focus-visible) {
    outline: 2px solid white;
    outline-offset: 2px;
  }
`;

const ColumnOptions = styled.fieldset`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 5px 12px;
  margin: 0;
  padding: 0;
  border: 0;
  color: white;
  font-size: 14px;
  font-weight: 600;

  label {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    margin: 0;
    cursor: pointer;
    white-space: nowrap;
  }
`;

const ColumnSortButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  width: 100%;
  min-height: 25px;
  padding: 0 5px;
  border: 0;
  background: transparent;
  color: var(--primary);
  font: inherit;
  text-transform: inherit;
  cursor: pointer;
  touch-action: manipulation;
`;

const chronologyColumns = [
  { key: "provider", label: "MEDICAL PROVIDER" },
  { key: "date", label: "DATE", spacer: true },
  { key: "cpt_codes", label: "CPT Codes", optional: true, spacer: true },
  { key: "diagnosis_codes", label: "Diagnosis Codes", optional: true, spacer: true },
  { key: "body_part", label: "Body Parts", optional: true, spacer: true },
  { key: "description", label: "TREATMENT NOTE", spacer: true },
  { key: "fees", label: "Fees" },
];

const ChronologySortButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 25px;
  width: 25px;
  height: 25px;
  padding: 0;
  border: 0;
  background: transparent;
  color: var(--primary);
  cursor: pointer;
  touch-action: manipulation;

  &::before {
    content: "";
    width: 15px;
    height: 15px;
    background-color: currentColor;
    mask: url(${sortIcon}) center / contain no-repeat;
    -webkit-mask: url(${sortIcon}) center / contain no-repeat;
  }

  &:hover,
  &:focus-visible {
    background: var(--primary-15);
  }

  &:focus-visible {
    outline: 2px solid currentColor;
    outline-offset: -2px;
  }
`;

const TreatmentDatesPageTable = ({
  treatmentDateData,
  setTreatmentDateData2,
  activeSpecialty,
  refetchTreatment,
  selectedGap,
  setSelectedGap,
  caseProvider,
  specialitie,
  isConsolidated,
  setIsConsolidated,
  datesTableLoading,
  visibleColumns,
  onColumnChange,
  columnsSaving,
}) => {
  const [fakeRows, setFakeRows] = useState([]);
  const tableWrapperRef = useRef(null);
  const [show, setShow] = useState(false);
  const [selectedDate, setSelectedDate] = useState(null);
  const [showGap, setShowGap] = useState(false);
  const [sort, setSort] = useState({ key: "date", direction: null });
  const columns = chronologyColumns.filter(
    (column) => !column.optional || visibleColumns[column.key]
  );
  const columnCount = columns.length + columns.filter((column) => column.spacer).length + 1;
  const nextSortDirection = (key) =>
    sort.key === key && sort.direction
      ? sort.direction === "asc"
        ? "desc"
        : "asc"
      : key === "date"
        ? "desc"
        : "asc";
  const handleColumnSort = (key) => setSort({ key, direction: nextSortDirection(key) });
  const caseSummary = useSelector((state) => state?.caseData?.summary);
  const handleClose = () => setShow(false);
  const page_id_click_record = useSelector(
    (state) => state.page_id_click_record.page_id_click_record
  );
  const [aiInfoOpen, setAiInfoOpen] = useState(false);

  const handleShow = (treatmentDate) => {
    if (treatmentDate?.date_type === "tf_date" || treatmentDate?.treatment_date?.id === null) {
      return;
    }
    setShow(true);
    setSelectedDate(treatmentDate);
  };

  const formatTFDateForInputTreatmentShowcase = (dateString) => {
    if (!dateString) return "";

    // If it's already a Date object
    if (dateString instanceof Date && !isNaN(dateString)) {
      return dateString.toLocaleDateString("en-US"); // e.g. 11/21/2017
    }

    if (typeof dateString === "string") {
      // Take only the part before the first space
      return formatDate(dateString.split(" ")[0]);
    }

    return "";
  };

  const getExpandedDateRows = (providerGroups = []) => {
    let currentDate = "";
    let currentBand = -1;
    let dateShown = false;

    return (providerGroups || []).map((group) =>
      (group?.dates || []).map((entry) => {
        const date = formatTFDateForInputTreatmentShowcase(entry?.treatment_date?.date);
        if (entry?.gap || !date) return { band: Math.max(currentBand, 0), showDate: false };

        if (date !== currentDate) {
          currentDate = date;
          currentBand += 1;
          dateShown = false;
        }

        const showDate =
          entry?.treatment_date?.id !== null &&
          (typeof entry?.show_date === "boolean"
            ? entry.show_date
            : (entry?.date_type === "date" || entry?.date_type === "both") && !dateShown);
        if (showDate) dateShown = true;

        return { band: currentBand, showDate };
      })
    );
  };

  const filteredData = React.useMemo(() => {
    if (!treatmentDateData) return [];

    const visibleData =
      activeSpecialty === "all"
        ? treatmentDateData
        : treatmentDateData.filter((item) => {
            const provider = isConsolidated ? item?.case_provider : item?.client_provider;
            return String(provider?.specialty?.id) === String(activeSpecialty);
          });

    return sortChronology(visibleData, isConsolidated, sort.direction, sort.key);
  }, [treatmentDateData, activeSpecialty, isConsolidated, sort]);
  const expandedDateRows = getExpandedDateRows(filteredData);
  const gapLabelMap = {
    "1 week": "one week",
    "2 weeks": "two weeks",
    "3 weeks": "three weeks",
    "30 days": "thirty days",
    "60 days": "sixty days",
    "90 days": "ninety days",
    "180 days": "one eighty days",
    "1 year": "one year",
    "Do not show gaps": "",
  };

  const fillTable = () => {
    const tableWrapper = tableWrapperRef.current;
    const tableBody = document.getElementById("table-body");

    if (tableWrapper && tableBody) {
      const tableHeight = tableWrapper.clientHeight - 25;
      const rowHeight = tableBody.firstChild?.offsetHeight || 25;
      const existingRows = filteredData?.length || 0;
      const rowsToFill = Math.floor(tableHeight / rowHeight) - existingRows;
      setFakeRows(
        rowsToFill > 0 ? Array.from({ length: rowsToFill }, (_, i) => ({ id: `empty-${i}` })) : []
      );
    }
  };

  useEffect(() => {
    const variableMedBillWidth = () => {
      const providerColumns = [...document.querySelectorAll(".provier-column-dates-treatment")];
      const datesColumn = [...document.querySelectorAll(".dates-column-dates-treatment")];
      if (providerColumns.length === 0 || datesColumn.length === 0) return;
      if (treatmentDateData) {
        let providerMaxWidth = 355;
        providerColumns.forEach((col) => {
          const colWidth = col.offsetWidth;
          if (colWidth > providerMaxWidth) {
            providerMaxWidth = colWidth;
          }
        });
        providerColumns.forEach((col) => {
          col.style.minWidth = `${providerMaxWidth}px`;
          col.style.width = `${providerMaxWidth}px`;
        });

        let dateMaxWidth = 91;
        datesColumn.forEach((col) => {
          const colWidth = col.offsetWidth;
          if (colWidth > dateMaxWidth) {
            dateMaxWidth = colWidth;
          }
        });
        datesColumn.forEach((col) => {
          col.style.minWidth = `${dateMaxWidth}px`;
          col.style.width = `${dateMaxWidth}px`;
        });
      }
    };

    // setMaxColumnWidth(calculateMaxWidth());
    variableMedBillWidth();
  }, [treatmentDateData]);

  useEffect(() => {
    fillTable();
    window.addEventListener("resize", fillTable);
    return () => window.removeEventListener("resize", fillTable);
  }, [filteredData, visibleColumns]);

  const _copyDate = async (id, date) => {
    const body = {
      provider_id: id,
      date,
    };

    try {
      const response = await api_without_cancellation.post(
        "/api/treatment-opt/copy-tfdate-to-date/",
        body
      );
      if (response.status === 200) {
        refetchTreatment(true);
      }
    } catch (error) {
      //
    }
  };
  const [enabled, setEnabled] = useState(false);
  const [aiDatePopup, setAIDatePopup] = useState(false);
  const [loader, setLoader] = useState(false);

  const { data } = useGetAISystem();

  const handleOptionChange = async (change) => {
    try {
      const response = await api_without_cancellation.post(
        `/api/treatment/dates_treatment/${getCaseId()}/`,
        {
          expanded: change,
          client_id: getClientId(),
        }
      );
      if (response.status === 200) {
        refetchTreatment(true);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    setEnabled(data?.is_medical_chronology_marked);
  }, [data]);

  useEffect(() => {
    if (!datesTableLoading) {
      setLoader(false);
    }
  }, [datesTableLoading]);

  const tdRef = useRef(null);
  // const [tdHeight, setTdHeight] = useState(0);

  // useLayoutEffect(() => {
  //   if (!tdRef.current) return;
  //   const ro = new ResizeObserver(([entry]) => {
  //     setTdHeight(entry.contentRect.height);
  //   });
  //   ro.observe(tdRef.current);
  //   return () => ro.disconnect();
  // }, [filteredData, isConsolidated, loader]);
  return (
    <ChronologyView>
      <div
        className="d-flex align-items-center justify-content-between"
        style={{
          minHeight: "35px",
          flexShrink: 0,
          flexWrap: "wrap",
          padding: "5px 0",
          background: "var(--primary)",
          width: "100%",
          gap: "5px 10px",
        }}
      >
        <div
          className="d-flex align-items-center "
          style={{
            gap: "10px",
            flexWrap: "wrap",
          }}
        >
          <DatesGapDropdown
            setTreatmentDateData2={setTreatmentDateData2}
            selectedGap={selectedGap}
            setSelectedGap={setSelectedGap}
            setShowGap={setShowGap}
          />
          {/* <div
            className="consolidate-toggle"
            onClick={() => {
              setLoader(true);
              handleOptionChange(!isConsolidated);
              setIsConsolidated(!isConsolidated);
            }}
            style={{
              display: "flex",
              alignItems: "center",
              gap: "5px",
              cursor: "pointer",
              userSelect: "none",
            }}
          >
            <div
              style={{
                position: "relative",
                width: "44px",
                height: "24px",
                backgroundColor: isConsolidated ? "green" : "var(--primary-25)",
                borderRadius: "12px",
                transition: "background-color 0.3s ease",
                padding: "2px",
              }}
            >
              <div
                style={{
                  position: "absolute",
                  width: "20px",
                  height: "20px",
                  backgroundColor: "white",
                  borderRadius: "50%",
                  top: "2px",
                  left: isConsolidated ? "22px" : "2px",
                  transition: "left 0.3s ease",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
                }}
              />
            </div>

            <span
              style={{
                fontWeight: "600",
                fontSize: "14px",
                color: "white",
              }}
            >
              {isConsolidated ? "Expanded" : "Consolidated"}
            </span>
          </div> */}
          <div
            className="consolidate-toggle"
            style={{ display: "flex", alignItems: "center", gap: "16px", userSelect: "none" }}
          >
            {[
              { label: "Consolidated", value: false },
              { label: "Expanded", value: true },
            ].map(({ label, value }) => {
              const selected = isConsolidated === value;
              return (
                <label
                  key={label}
                  className="mb-0"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "5px",
                    cursor: "pointer",
                    fontWeight: "600",
                    fontSize: "14px",
                    color: "white",
                  }}
                >
                  <span
                    style={{
                      position: "relative",
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "14px",
                      height: "14px",
                      border: "1px solid white",
                      borderRadius: "50%",
                      backgroundColor: "transparent",
                    }}
                  >
                    {selected && (
                      <span
                        style={{
                          width: "8px",
                          height: "8px",
                          borderRadius: "50%",
                          backgroundColor: "white",
                        }}
                      />
                    )}
                  </span>
                  <input
                    type="radio"
                    name="consolidate-mode"
                    checked={selected}
                    onChange={() => {
                      if (isConsolidated === value) return;
                      setLoader(true);
                      handleOptionChange(value);
                      setIsConsolidated(value);
                    }}
                    style={{ position: "absolute", opacity: 0, pointerEvents: "none" }}
                  />
                  {label}
                </label>
              );
            })}
          </div>
          <ColumnOptions disabled={columnsSaving} aria-busy={columnsSaving}>
            <legend className="visually-hidden">Show chronology columns</legend>
            {chronologyColumns
              .filter((column) => column.optional)
              .map((column) => (
                <label key={column.key}>
                  <input
                    type="checkbox"
                    name={`show-${column.key}`}
                    checked={visibleColumns[column.key]}
                    onChange={(event) => onColumnChange(column.key, event.target.checked)}
                  />
                  {column.label}
                </label>
              ))}
          </ColumnOptions>
        </div>
        <div
          className="d-flex align-items-center justify-content-end"
          style={{
            gap: "10px",
            flexShrink: 0,
            marginLeft: "auto",
          }}
        >
          <div className="d-flex align-items-center justify-content-end p-r-5">
            <Button
              variant={"success"}
              className="button-padding-footer-new-provider height-25 d-flex align-items-center justify-content-center"
              style={{ width: "150px", gap: "5px", whiteSpace: "nowrap" }}
              onClick={() => setAIDatePopup(true)}
            >
              <span className="d-flex align-items-center justify-content-center ic">
                <img
                  src={addIconGold}
                  style={{
                    flexShrink: "0",
                  }}
                  className="ic ic-15 d-flex align-items-center justify-content-center"
                />
              </span>{" "}
              Treatment Date
            </Button>
          </div>
          <div className="d-flex align-items-center justify-content-end p-r-5">
            <Button
              variant={enabled ? "success" : "secondary"}
              className="button-padding-footer-new-provider height-25 d-flex align-items-center justify-content-center"
              style={{ width: "25px", border: "none", maxWidth: "25px" }}
              onClick={() => setAiInfoOpen(true)}
            >
              <span className="d-flex align-items-center justify-content-center ic">
                <img
                  src={powerbtn}
                  style={{
                    flexShrink: "0",
                  }}
                  className="ic ic-15 d-flex align-items-center justify-content-center"
                />
              </span>
            </Button>
          </div>
        </div>
      </div>
      <div
        ref={tableWrapperRef}
        className="invisible-scrollbar"
        style={{ flex: "1 1 0", minHeight: 0, overflowY: "auto", width: "100%" }}
      >
        <table
          className={isConsolidated ? "" : "table-striped"}
          style={{ width: "100%", tableLayout: "auto", whiteSpace: "nowrap" }}
        >
          <thead
            style={{
              // backgroundColor: "var(--primary-15)",
              padding: "0px",
              position: "sticky",
              top: "0px",
              // width: "100%",
            }}
            className="bg-primary-5 text-white text-center color-primary c-font-weight-600"
          >
            <tr style={{ height: "25px" }}>
              {columns.map((column) => (
                <React.Fragment key={column.key}>
                  <th
                    scope="col"
                    className={
                      column.key === "provider"
                        ? "td-autosize text-center provier-column-dates-treatment"
                        : `text-center ${isConsolidated || column.key === "date" || column.key === "fees" ? "td-autosize" : "td-autosize-2"}`
                    }
                    style={{ padding: 0, ...(column.key === "date" ? { minWidth: "70px" } : {}) }}
                    aria-sort={
                      sort.key === column.key && sort.direction
                        ? sort.direction === "asc"
                          ? "ascending"
                          : "descending"
                        : undefined
                    }
                  >
                    <ColumnSortButton
                      type="button"
                      title={`Sort by ${column.label.toLowerCase()}: ${nextSortDirection(column.key) === "asc" ? "ascending" : "descending"}`}
                      onClick={() => handleColumnSort(column.key)}
                    >
                      {column.label}
                    </ColumnSortButton>
                  </th>
                  {column.spacer && <th style={{ minWidth: "5px" }} aria-hidden="true" />}
                </React.Fragment>
              ))}
              <th
                scope="col"
                style={{ padding: 0, minWidth: "25px", maxWidth: "25px", width: "25px" }}
              >
                <ChronologySortButton
                  type="button"
                  aria-label={`Sort chronology by date, ${nextSortDirection("date") === "desc" ? "newest" : "oldest"} first`}
                  title={`Sort by date: ${nextSortDirection("date") === "desc" ? "newest" : "oldest"} first`}
                  onClick={() => handleColumnSort("date")}
                />
              </th>
            </tr>
          </thead>
          <tbody id="table-body" className={`has-speciality-color-${activeSpecialty}`}>
            {loader && <PulseLoader />}
            {!loader &&
              isConsolidated &&
              filteredData?.map((providerGroup, groupIndex) => {
                const provider = providerGroup?.case_provider;
                const specialty = provider?.specialty;
                const dateRows = expandedDateRows[groupIndex];
                const firstTreatmentIndex = providerGroup?.dates?.findIndex(
                  (entry) => !entry?.gap && entry?.treatment_date?.id !== null
                );

                return (
                  <React.Fragment key={`provider-${provider?.id}-${groupIndex}`}>
                    <ClientProvidersStyles clientProviders={[{ specialty: { ...specialty } }]} />
                    {providerGroup?.dates?.map((dateEntry, dateIndex) => {
                      const isFirstDate = dateIndex === firstTreatmentIndex;
                      const { band: dateBand, showDate } = dateRows[dateIndex];
                      const rowSpecialtyId =
                        activeSpecialty !== "all" ? activeSpecialty : specialty?.id;
                      const rowTintClass = rowSpecialtyId
                        ? `has-speciality-color-${rowSpecialtyId} bg-speciality-${dateBand % 2 === 0 ? "2" : "4"}`
                        : `bg-primary-${dateBand % 2 === 0 ? "2" : "4"}`;
                      const treatmentDateData = {
                        ...dateEntry,
                        client_provider: provider,
                      };

                      if (dateEntry?.gap) {
                        return (
                          <tr
                            key={`gap-${provider?.id}-${dateIndex}`}
                            className={rowTintClass}
                            style={{ height: "25px", textAlign: "center", cursor: "default" }}
                          >
                            <td
                              colSpan={columnCount}
                              style={{ fontWeight: "600", textAlign: "center", color: "red" }}
                            >
                              {selectedGap !== "Do not show gaps" && !showGap && (
                                <>
                                  Treatment gap longer than{" "}
                                  {gapLabelMap[selectedGap] || selectedGap}
                                </>
                              )}
                            </td>
                          </tr>
                        );
                      }

                      if (dateEntry?.treatment_date?.id === null) {
                        return (
                          <tr
                            key={`incident-${provider?.id}-${dateIndex}`}
                            className={rowTintClass}
                            style={{ height: "25px", textAlign: "center", cursor: "default" }}
                          >
                            <td
                              colSpan={columnCount}
                              style={{ fontWeight: "600", textAlign: "center" }}
                            >
                              <div
                                className="d-flex align-items-center justify-content-center"
                                style={{ gap: "5px" }}
                              >
                                {caseSummary?.case_type?.casetype_icon && (
                                  <img
                                    src={caseSummary?.case_type?.casetype_icon}
                                    alt="Case"
                                    style={{ width: "15px", height: "15px" }}
                                  />
                                )}
                                <span style={{ fontSize: "15px", fontWeight: "600" }}>
                                  {caseSummary?.case_type?.name}
                                </span>
                                <span className="mx-1">-</span>
                                <img
                                  src={incidentIcon}
                                  alt="incident"
                                  style={{ width: "15px", height: "15px" }}
                                />
                                <span style={{ fontSize: "15px", fontWeight: "600" }}>
                                  {formatTFDateForInputTreatmentShowcase(
                                    dateEntry?.treatment_date?.date
                                  )}
                                </span>
                              </div>
                            </td>
                          </tr>
                        );
                      }

                      return (
                        <tr
                          key={`${provider?.id}-${dateEntry?.treatment_date?.id}-${dateIndex}`}
                          className={`${rowTintClass} hover-background-row`}
                          style={{ height: "25px", textAlign: "left", cursor: "default" }}
                          onClick={() => {
                            addClickRecord(999, page_id_click_record);
                            handleShow(treatmentDateData);
                          }}
                        >
                          <td className="provier-column-dates-treatment ps-0 pt-0 pb-0">
                            {isFirstDate ? (
                              <LightBgParagraph
                                speciality={
                                  specialty || { color: "#19395f", secondary_color: "#75889f" }
                                }
                              >
                                <div
                                  className="d-flex align-items-center"
                                  style={{ height: "25px" }}
                                >
                                  <span
                                    className="d-inline-flex align-items-center justify-content-center"
                                    style={{
                                      backgroundColor: specialty?.color,
                                      fontSize: "16px",
                                      fontWeight: "600",
                                      color: "white",
                                      height: "25px",
                                      width: "25px",
                                    }}
                                  >
                                    {specialty?.name?.[0]}
                                  </span>
                                  <span
                                    style={{
                                      paddingLeft: "5px",
                                      paddingRight: "5px",
                                      fontWeight: "600",
                                    }}
                                  >
                                    {provider?.treatment_location?.name}
                                  </span>
                                </div>
                              </LightBgParagraph>
                            ) : (
                              <div style={{ height: "25px" }} />
                            )}
                          </td>

                          <td style={{ fontWeight: "600" }}>
                            <div className="d-flex align-items-center justify-content-end">
                              <p>
                                {showDate
                                  ? formatTFDateForInputTreatmentShowcase(
                                      dateEntry?.treatment_date?.date
                                    )
                                  : ""}
                              </p>
                            </div>
                          </td>
                          <td />
                          {visibleColumns.cpt_codes && (
                            <React.Fragment>
                              <td style={{ fontWeight: "600" }} className="text-end">
                                {dateEntry?.treatment_date?.cpt_codes}{" "}
                                {dateEntry?.treatment_date?.procedure_code_modifiers
                                  ? `- ${dateEntry?.treatment_date?.procedure_code_modifiers}`
                                  : ""}
                              </td>
                              <td />
                            </React.Fragment>
                          )}

                          {visibleColumns.diagnosis_codes && (
                            <React.Fragment>
                              <td style={{ fontWeight: "600" }} className="text-end">
                                {dateEntry?.treatment_date?.diagnosis_codes}
                              </td>
                              <td />
                            </React.Fragment>
                          )}

                          {visibleColumns.body_part && (
                            <React.Fragment>
                              <td style={{ fontWeight: "600" }} className="text-end">
                                {dateEntry?.treatment_date?.body_part}
                              </td>
                              <td />
                            </React.Fragment>
                          )}

                          <td className="text-start" style={{ fontWeight: "600" }}>
                            {dateEntry?.date_type !== "tf_date"
                              ? dateEntry?.treatment_date?.description
                              : ""}
                          </td>
                          <td />

                          <td style={{ fontWeight: "600" }} className="text-end">
                            {currencyFormat(dateEntry?.treatment_date?.fees)}
                          </td>
                          <td />
                        </tr>
                      );
                    })}
                  </React.Fragment>
                );
              })}
            {/* {!loader &&
              isConsolidated &&
              filteredData?.map((treatmentDateData, index) => (
                <>
                  <ClientProvidersStyles
                    clientProviders={[
                      { specialty: { ...treatmentDateData?.client_provider?.specialty } },
                    ]}
                  />
                  {treatmentDateData?.gap ? (
                    <tr
                      className={
                        activeSpecialty !== "all"
                          ? `has-speciality-color-${activeSpecialty} ${
                              index % 2 === 0 ? "bg-speciality-2" : "bg-speciality-4"
                            }`
                          : `${index % 2 === 0 ? "bg-primary-2" : "bg-primary-4"} hover-background-row`
                      }
                      style={{ height: "25px", textAlign: "center", cursor: "default" }}
                      key={`gap-${treatmentDateData?.client_provider?.id}-${index}`}
                    >
                      <td
                        colSpan="16"
                        style={{ fontWeight: "600", textAlign: "center", color: "red" }}
                      >
                        {selectedGap !== "Do not show gaps" && !showGap && (
                          <>Treatment gap longer than {gapLabelMap[selectedGap] || selectedGap}</>
                        )}
                      </td>
                    </tr>
                  ) : treatmentDateData?.treatment_date?.id === null ? (
                    // FULL-WIDTH INCIDENT DATE ROW
                    <tr
                      className={
                        activeSpecialty !== "all"
                          ? `has-speciality-color-${activeSpecialty} ${
                              index % 2 === 0 ? "bg-speciality-2" : "bg-speciality-4"
                            }`
                          : `${index % 2 === 0 ? "bg-primary-2" : "bg-primary-4"} hover-background-row`
                      }
                      style={{ height: "25px", textAlign: "center", cursor: "default" }}
                      key={`incident-${treatmentDateData?.client_provider?.id}-${index}`}
                    >
                      <td
                        colSpan="16"
                        style={{
                          fontWeight: "600",
                          textAlign: "center",
                        }}
                      >
                        <div
                          className="d-flex align-items-center justify-content-center"
                          style={{
                            gap: "5px",
                          }}
                        >
                          <img
                            src={caseSummary?.case_type?.casetype_icon}
                            alt="Case"
                            style={{ width: "15px", height: "15px" }}
                          />
                          <span style={{ fontSize: "15px", fontWeight: "600" }}>
                            {caseSummary?.case_type?.name}
                          </span>
                          <span className="mx-1">-</span>

                          <img
                            src={incidentIcon}
                            alt="incident"
                            style={{ width: "15px", height: "15px" }}
                          />
                          <span style={{ fontSize: "15px", fontWeight: "600" }}>
                            {formatTFDateForInputTreatmentShowcase(
                              treatmentDateData?.treatment_date?.date
                            )}
                          </span>
                        </div>
                      </td>
                    </tr>
                  ) : (
                    <tr
                      className={
                        activeSpecialty !== "all"
                          ? `has-speciality-color-${activeSpecialty} ${
                              index % 2 === 0 ? "bg-speciality-2" : "bg-speciality-4"
                            }`
                          : treatmentDateData?.client_provider?.specialty?.id
                            ? `has-speciality-color-${treatmentDateData.client_provider.specialty.id} ${
                                index % 2 === 0
                                  ? "bg-speciality-2 hover-background-row"
                                  : "bg-speciality-4 hover-background-row"
                              }`
                            : `${index % 2 === 0 ? "bg-primary-2" : "bg-primary-4"} hover-background-row`
                      }
                      style={{ height: "25px", textAlign: "left", cursor: "default" }}
                      key={`${treatmentDateData?.client_provider?.id}-${treatmentDateData?.treatment_date?.id}-${index}`}
                      onClick={() => {
                        addClickRecord(999, page_id_click_record);
                        handleShow(treatmentDateData);
                      }}
                    >
                      <td className="provier-column-dates-treatment ps-0 pt-0 pb-0">
                        <LightBgParagraph
                          speciality={
                            treatmentDateData?.client_provider?.specialty || {
                              color: "#19395f",
                              secondary_color: "#75889f",
                            }
                          }
                        >
                          <div className="d-flex align-items-center" style={{ height: "25px" }}>
                            <span
                              className="d-inline-flex align-items-center justify-content-center"
                              style={{
                                backgroundColor:
                                  treatmentDateData?.client_provider?.specialty?.color,
                                fontSize: "16px",
                                fontWeight: "600",
                                color: "white",
                                height: "25px",
                                width: "25px",
                              }}
                            >
                              {treatmentDateData?.client_provider?.specialty?.name[0]}
                            </span>
                            <span
                              style={{
                                paddingLeft: "5px",
                                paddingRight: "5px",
                                fontWeight: "600",
                              }}
                              className=""
                            >
                              {treatmentDateData?.client_provider?.treatment_location?.name}
                            </span>
                          </div>
                        </LightBgParagraph>
                      </td>
                      <td style={{ fontWeight: "600" }}>
                        <div className="d-flex align-items-center justify-content-end">
                          <p>
                            {treatmentDateData?.date_type === "date" ||
                            treatmentDateData?.date_type === "both"
                              ? formatTFDateForInputTreatmentShowcase(
                                  treatmentDateData?.treatment_date?.date
                                )
                              : ""}
                          </p>
                        </div>
                      </td>
                     
                      <td
                        style={{
                          fontWeight: "600",
                        }}
                        className="text-end"
                      >
                        {treatmentDateData?.treatment_date?.cpt_codes}{" "}
                        {treatmentDateData?.treatment_date?.procedure_code_modifiers
                          ? `- ${treatmentDateData?.treatment_date?.procedure_code_modifiers}`
                          : ""}
                      </td>
                      <td />

                      <td
                        style={{
                          fontWeight: "600",
                        }}
                        className="text-end"
                      >
                        {treatmentDateData?.treatment_date?.diagnosis_codes}
                      </td>
                      <td />

                      <td
                        style={{
                          fontWeight: "600",
                        }}
                        className="text-end"
                      >
                        {treatmentDateData?.treatment_date?.body_part}
                      </td>
                      <td />
                      <td style={{ fontWeight: "600" }}>
                        {treatmentDateData?.date_type !== "tf_date"
                          ? treatmentDateData?.treatment_date?.description
                          : ""}
                      </td>
                      <td />
                      <td
                        style={{
                          fontWeight: "600",
                        }}
                        className="text-end"
                      >
                        {currencyFormat(treatmentDateData?.treatment_date?.fees)}
                      </td>
                      <td />
                    </tr>
                  )}
                </>
              ))} */}
            {!loader &&
              !isConsolidated &&
              filteredData?.map((treatmentDateData, index) => (
                <React.Fragment
                  key={`${treatmentDateData?.client_provider?.id}-${treatmentDateData?.treatment_date?.id}-${index}`}
                >
                  <ClientProvidersStyles
                    clientProviders={[
                      { specialty: { ...treatmentDateData?.client_provider?.specialty } },
                    ]}
                  />
                  {treatmentDateData?.gap ? (
                    <tr
                      className={
                        activeSpecialty !== "all"
                          ? `has-speciality-color-${activeSpecialty} ${
                              index % 2 === 0 ? "bg-speciality-2" : "bg-speciality-4"
                            }`
                          : `${index % 2 === 0 ? "bg-primary-2" : "bg-primary-4"} hover-background-row`
                      }
                      style={{ height: "25px", textAlign: "center", cursor: "default" }}
                      key={`gap-${treatmentDateData?.client_provider?.id}-${index}`}
                    >
                      <td
                        colSpan={columnCount}
                        style={{ fontWeight: "600", textAlign: "center", color: "red" }}
                      >
                        {selectedGap !== "Do not show gaps" && !showGap && (
                          <>Treatment gap longer than {gapLabelMap[selectedGap] || selectedGap}</>
                        )}
                      </td>
                    </tr>
                  ) : treatmentDateData?.treatment_date?.id === null ? (
                    // FULL-WIDTH INCIDENT DATE ROW
                    <tr
                      className={
                        activeSpecialty !== "all"
                          ? `has-speciality-color-${activeSpecialty} ${
                              index % 2 === 0 ? "bg-speciality-2" : "bg-speciality-4"
                            }`
                          : `${index % 2 === 0 ? "bg-primary-2" : "bg-primary-4"} hover-background-row`
                      }
                      style={{ height: "25px", textAlign: "center", cursor: "default" }}
                      key={`incident-${treatmentDateData?.client_provider?.id}-${index}`}
                    >
                      <td
                        colSpan={columnCount}
                        style={{
                          fontWeight: "600",
                          textAlign: "center",
                        }}
                      >
                        <div
                          className="d-flex align-items-center justify-content-center"
                          style={{
                            gap: "5px",
                          }}
                        >
                          {caseSummary?.case_type?.casetype_icon && (
                            <img
                              src={caseSummary?.case_type?.casetype_icon}
                              alt="Case"
                              style={{ width: "15px", height: "15px" }}
                            />
                          )}
                          <span style={{ fontSize: "15px", fontWeight: "600" }}>
                            {caseSummary?.case_type?.name}
                          </span>
                          <span className="mx-1">-</span>

                          <img
                            src={incidentIcon}
                            alt="incident"
                            style={{ width: "15px", height: "15px" }}
                          />
                          <span style={{ fontSize: "15px", fontWeight: "600" }}>
                            {formatTFDateForInputTreatmentShowcase(
                              treatmentDateData?.treatment_date?.date
                            )}
                          </span>
                        </div>
                      </td>
                    </tr>
                  ) : (
                    // REGULAR TREATMENT ROW
                    <tr
                      className={
                        activeSpecialty !== "all"
                          ? `has-speciality-color-${activeSpecialty} ${
                              index % 2 === 0 ? "bg-speciality-2" : "bg-speciality-4"
                            }`
                          : treatmentDateData?.client_provider?.specialty?.id
                            ? `has-speciality-color-${treatmentDateData.client_provider.specialty.id} ${
                                index % 2 === 0
                                  ? "bg-speciality-2 hover-background-row"
                                  : "bg-speciality-4 hover-background-row"
                              }`
                            : `${index % 2 === 0 ? "bg-primary-2" : "bg-primary-4"} hover-background-row`
                      }
                      style={{
                        minHeight: "25px",
                        maxHeight: "50px",
                        textAlign: "left",
                        cursor: "default",
                      }}
                      key={`${treatmentDateData?.client_provider?.id}-${treatmentDateData?.treatment_date?.id}-${index}`}
                      onClick={() => {
                        addClickRecord(999, page_id_click_record);
                        handleShow(treatmentDateData);
                      }}
                    >
                      <td ref={tdRef} className="provier-column-dates-treatment ps-0 pt-0 pb-0">
                        <LightBgParagraph
                          speciality={
                            treatmentDateData?.client_provider?.specialty || {
                              color: "#19395f",
                              secondary_color: "#75889f",
                            }
                          }
                        >
                          <div className="d-flex align-items-center" style={{ height: "25px" }}>
                            <span
                              className="d-inline-flex align-items-center justify-content-center"
                              style={{
                                backgroundColor:
                                  treatmentDateData?.client_provider?.specialty?.color,
                                fontSize: "16px",
                                fontWeight: "600",
                                color: "white",
                                height: "25px",
                                width: "25px",
                              }}
                            >
                              {treatmentDateData?.client_provider?.specialty?.name[0]}
                            </span>
                            <span
                              style={{
                                paddingLeft: "5px",
                                paddingRight: "5px",
                                fontWeight: "600",
                              }}
                              className=""
                            >
                              {treatmentDateData?.client_provider?.treatment_location?.name}
                            </span>
                          </div>
                        </LightBgParagraph>
                      </td>
                      <td style={{ fontWeight: "600" }}>
                        <div className="d-flex align-items-center justify-content-end">
                          <p>
                            {treatmentDateData?.date_type === "date" ||
                            treatmentDateData?.date_type === "both"
                              ? formatTFDateForInputTreatmentShowcase(
                                  treatmentDateData?.treatment_date?.date
                                )
                              : ""}
                          </p>
                        </div>
                      </td>
                      {/* <td className="treatment-date-cell">
                        <span className="date-text">
                          {treatmentDateData?.date_type === "tf_date" ||
                          treatmentDateData?.date_type === "both"
                            ? formatTFDateForInputTreatmentShowcase(
                                treatmentDateData?.treatment_date?.date
                              )
                            : ""}
                        </span>

                        {treatmentDateData?.date_type === "tf_date" &&
                        treatmentDateData?.treatment_date?.date ? (
                          <div
                            className="copy-tfdate-centered"
                            onClick={(e) => {
                              e.stopPropagation();
                              addClickRecord(999, page_id_click_record);
                              copyDate(
                                treatmentDateData?.client_provider?.id,
                                treatmentDateData?.treatment_date?.date
                              );
                            }}
                          >
                            <img src={chevronRight} className="ic-19" alt="copy icon" />
                            <span>Copy</span>
                          </div>
                        ) : null}
                      </td> */}
                      {/* <td /> */}
                      <td />
                      {visibleColumns.cpt_codes && (
                        <React.Fragment>
                          <td
                            style={{
                              fontWeight: "600",
                            }}
                            className="text-end "
                          >
                            <div
                              className=""
                              style={{
                                display: "-webkit-box",
                                WebkitLineClamp: 1,
                                WebkitBoxOrient: "vertical",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                wordBreak: "normal",
                                // maxWidth: "400px",
                                whiteSpace: "normal",
                                minWidth: "100%",
                                paddingRight: "5px",
                              }}
                            >
                              {treatmentDateData?.treatment_date?.cpt_codes}{" "}
                              {treatmentDateData?.treatment_date?.procedure_code_modifiers
                                ? `- ${treatmentDateData?.treatment_date?.procedure_code_modifiers}`
                                : ""}
                            </div>
                          </td>
                          <td />
                        </React.Fragment>
                      )}
                      {visibleColumns.diagnosis_codes && (
                        <React.Fragment>
                          <td
                            style={{
                              fontWeight: "600",
                              // minWidth: "50%",
                            }}
                            className="text-end "
                          >
                            <div
                              style={{
                                display: "-webkit-box",
                                WebkitLineClamp: 1,
                                WebkitBoxOrient: "vertical",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                wordBreak: "normal",
                                // maxWidth: "500px",
                                whiteSpace: "normal",
                                minWidth: "100%",
                                paddingRight: "5px",
                              }}
                            >
                              {treatmentDateData?.treatment_date?.diagnosis_codes}
                            </div>
                          </td>
                          <td />
                        </React.Fragment>
                      )}
                      {visibleColumns.body_part && (
                        <React.Fragment>
                          <td
                            style={{
                              fontWeight: "600",
                              // minWidth: "10%",
                            }}
                            className="text-end "
                          >
                            <div
                              style={{
                                display: "-webkit-box",
                                WebkitLineClamp: 1,
                                WebkitBoxOrient: "vertical",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                wordBreak: "normal",
                                // maxWidth: "500px",
                                whiteSpace: "normal",
                                minWidth: "100%",
                                paddingRight: "5px",
                              }}
                            >
                              {treatmentDateData?.treatment_date?.body_part}
                            </div>
                          </td>
                          <td />
                        </React.Fragment>
                      )}
                      <td style={{ fontWeight: "600" }} className="">
                        <div
                          style={{
                            display: "-webkit-box",
                            WebkitLineClamp: 1,
                            WebkitBoxOrient: "vertical",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            wordBreak: "normal",
                            // maxWidth: "500px",
                            whiteSpace: "normal",
                            minWidth: "100%",
                            paddingRight: "5px",
                          }}
                        >
                          {treatmentDateData?.date_type !== "tf_date"
                            ? treatmentDateData?.treatment_date?.description
                            : ""}
                        </div>
                      </td>
                      <td />
                      <td
                        style={{
                          fontWeight: "600",
                        }}
                        className="text-end "
                      >
                        {currencyFormat(treatmentDateData?.treatment_date?.fees)}
                      </td>
                      <td />
                    </tr>
                  )}
                </React.Fragment>
              ))}
            {fakeRows.map((row, index) => {
              const globalIndex = filteredData?.length + index;

              return (
                <tr
                  className={
                    activeSpecialty !== "all" && filteredData.length !== 0
                      ? `height-25 has-speciality-color-${activeSpecialty} ${
                          globalIndex % 2 === 0 ? "bg-speciality-2" : "bg-speciality-4"
                        }`
                      : `height-25 ${
                          globalIndex % 2 === 0
                            ? "bg-primary-2 hover-background-row"
                            : "bg-primary-4 hover-background-row"
                        }`
                  }
                  key={row.id}
                >
                  <td colSpan={columnCount} style={{ height: isConsolidated ? "25px" : "25px" }} />
                </tr>
              );
            })}
          </tbody>
        </table>

        {show && (
          <EditDeleteModal
            treatmentDateData={treatmentDateData}
            date={selectedDate?.treatment_date}
            show={show}
            handleClose={handleClose}
            setAllTreatmentDates={setTreatmentDateData2}
            key={selectedDate?.treatment_date?.id}
            caseProvider={{
              providerprofile_office_name: selectedDate?.client_provider?.treatment_location?.name,
            }}
            refetchTreatment={refetchTreatment}
          />
        )}
        {aiDatePopup && (
          <>
            <AddAIDateModal
              show={aiDatePopup}
              handleClose={() => setAIDatePopup(false)}
              caseProvider={caseProvider}
              specialitie={specialitie}
              refetchTreatment={refetchTreatment}
            />
          </>
        )}
        {aiInfoOpen && (
          <AIFunctionalityModal
            show={aiInfoOpen}
            handleClose={() => setAiInfoOpen(false)}
            pageName="Treatment"
            tabName="Chronology"
            firmName={"Silverthorne Attorneys X"}
            creditBalance={0.0}
          />
        )}
      </div>
    </ChronologyView>
  );
};

export default React.memo(TreatmentDatesPageTable);
